import { PayloadAction } from 'typesafe-actions';
import { CommunicationProviderState, CommunicationActionTypes } from './types';

const CommunicationReducer = (
  state: CommunicationProviderState,
  action: PayloadAction<CommunicationActionTypes, any>,
): CommunicationProviderState => {
  switch (action.type) {
    case CommunicationActionTypes.setCommunicationAlerts:
      return {
        ...state,
        communicationAlertsList: action.payload,
      };
    default: {
      return state;
    }
  }
};

export { CommunicationReducer };
